<template>
    <div v-if="value.url" class="news-item">
        <span class="text">
            <a :href="value.url"
               target="_blank"
               rel="noopener noreferrer"
               title="value.text"
               v-text="value.text" />
        </span>
    </div>
    <div v-else class="news-item">
        <span class="text">
            {{ value.text }}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object,
                required: true
            }
        }
    };
</script>

<style>
    @import '../css/main.css';
</style>
